import React from 'react'
import { Link } from 'react-router-dom'
import { OscForm } from '../../components/OscForm'
import { RegisterProgress } from '../../components/OscForm/RegisterProgress'
import { RegisterProvider } from '../../context/RegisterContext'
import { BRAND_LOGO } from '../../utils/constants'

export const Register = () => {

    return (
        <RegisterProvider>
        <div className='w-full grid grid-cols-12'>
            <div className='grid grid-cols-1 col-span-10 md:col-span-8 col-start-2 md:col-start-3  md:mt-6 mt-3 px-6' >
                <div className='grid grid-cols-2'>
                    <div className='text-2xl text-gray-600 font-bold'>Cadastro</div>

                    <div className='flex flex-col items-end'>
                        <Link to="/osc"><img src={BRAND_LOGO} width={78} alt={'logo'} /></Link>
                    </div>
                </div>
                <RegisterProgress  />
                <div className='px-2'>
                <OscForm  />
                </div>
            </div>
        </div>
        </RegisterProvider>
    )
}
